import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/home-page/home-page').then((module) => module.HomePage),
  },
  {
    path: 'companies/:companyId',
    loadComponent: () => import('./components/company-detail/company-detail').then((module) => module.CompanyDetail),
  },

  {
    path: 'admin',
    loadComponent: () => import('./components/admin-page/admin-page').then((module) => module.AdminPage),
  },
  {
    path: 'profile',
    loadComponent: () => import('./components/profile-page/profile-page').then((module) => module.ProfilePage),
  },
  {
    path: 'users/:userId',
    loadComponent: () => import('./components/user-detail/user-detail').then((module) => module.UserDetail),
  },
  {
    path: 'styleguide',
    loadComponent: () => import('./components/all-components/all-components').then((module) => module.AllComponents),
  },
];
